import { Bookmark, Bookmarks } from "@mui/icons-material";
import { FormFieldValueGroupUI } from "Backend";

export function ReferenceIcon({ row, onClick }: { row: FormFieldValueGroupUI; onClick: () => void }) {
  if (row.references.length === 0) {
    return (
      <span className="inline-flex items-center gap-0.5 cursor-not-allowed">
        <Bookmark className="text-gray-200" />
        <p className="invisible">0</p>
      </span>
    );
  }
  return (
    <span className="inline-flex items-center gap-0.5" onClick={onClick}>
      {row.references.length > 1 ? <Bookmarks className="text-gray-700" /> : <Bookmark className="text-gray-700" />}
      <p className="invisible">0</p>
    </span>
  );
}
